import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-goods')) {
  document.querySelectorAll('.swiper').forEach((swiper) => {
    new Swiper(swiper, {
      loop: true,
      // ページネーションが必要なら追加
      pagination: {
        el: swiper.querySelector('.swiper-pagination'),
      },
      // ナビボタンが必要なら追加
      navigation: {
        nextEl: swiper.querySelector('.swiper-button-next'),
        prevEl: swiper.querySelector('.swiper-button-prev'),
      },
    })
  })

  /**
   * 背景切り替え
   */
  // const bg = document.querySelector('.pageBg--goods1')
  // const bgRangeStartEl = document.querySelector('.goodsMenu#collabo')
  // const bgRangeEndEl = document.querySelector('.goodsGuide')

  // const adjustBg = () => {
  //   const scrollTop = document.documentElement.scrollTop
  //   const rangePoint = scrollTop + document.documentElement.clientHeight * 0.5
  //   const rangeTop = bgRangeStartEl.getBoundingClientRect().top + scrollTop
  //   const rangeBottom = bgRangeEndEl.getBoundingClientRect().top + scrollTop

  //   if (rangeTop <= rangePoint && rangePoint <= rangeBottom) {
  //     bg.classList.add('is-hide')
  //   } else {
  //     bg.classList.remove('is-hide')
  //   }
  // }

  // window.addEventListener('resize', adjustBg)
  // window.addEventListener('scroll', adjustBg)
  // adjustBg()
}
